import { Box, Text } from '@chakra-ui/react'
import { memo, useCallback } from 'react'

import { ListToolbar } from '@mangovoice/mango-ui'
import type { TranslateFn } from '@mangovoice/mango-ui'

import { useDevicesI18n } from '../i18n'

interface DevicesListToolbarProps {
  pageSize: number | 'All'
  onPageSizeChange: (size: number | 'All') => void
  currentPage: number
  totalCount: number
  onPageChange: (page: number) => void
  isLoading: boolean
  showToolbar: boolean
}

const TOOLBAR_FALLBACKS: Record<string, string> = {
  'devices.pagination.resultsPerPage': 'Results per page:',
  'devices.pagination.all': 'All',
  'devices.pagination.previousPage': 'Previous page',
  'devices.pagination.nextPage': 'Next page',
  'devices.pagination.jumpToPage': 'Jump to page {{page}}',
}

export const DevicesListToolbar = memo<DevicesListToolbarProps>((props) => {
  const { text } = useDevicesI18n()
  const t: TranslateFn = useCallback(
    (key, opts) =>
      text(
        key,
        TOOLBAR_FALLBACKS[key] ?? key,
        opts as Record<string, string | number> | undefined,
      ),
    [text],
  )

  return (
    <Box px={4}>
      <ListToolbar
        {...props}
        showAllOption
        maxAllThreshold={Number.MAX_SAFE_INTEGER}
        t={t}
        i18nPrefix="devices.pagination"
        summary={
          <Text fontSize="sm" color="fg.subtle">
            {text('devices.pagination.totalCount', '({{count}} total)', {
              count: props.totalCount,
            })}
          </Text>
        }
      />
    </Box>
  )
})

DevicesListToolbar.displayName = 'DevicesListToolbar'
